import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import {
  Avatar,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material';
import ExpandeRowClases from './ExpandedRowClases';
import {
  deleteClasesAction,
  getAllClasesAction,
  saveClasesAction,
  setActivoClasesAction,
} from '../ClasesAction';
import ActionsList from '../../../../components/ActionsList';
import VisibilityIcon from '@mui/icons-material/Visibility';
import * as ROUTES from '../../../../router/Routes';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { Modal } from '../../../../components';
import { textLabelsTable } from '../../../invitados/components/ListadoInvitados';
import { CYAN_COLOR, MORADO_COLOR } from '../../../../constants/ColorsConst';
import LoadingComponent from '../../../../components/Loading';
import { downloadExcelFile } from '../../../../helpers/exportHelper';
import { useNotification } from '../../../../helpers/notification';
import { NameComponent } from '../../../usuarios/components/ListadoUsuarios';
import { PARAMS_CLASES } from '../ClasesReducer';
import { clasesApi } from '../ClasesService';
import moment from 'moment';
import { SU } from '../../../../constants/ConfigConst';
import { isManagerUserCode } from '../../../modulos/modules.helpers';

const ListadoClases = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { addNotification } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const clasesStore = Redux.useSelector((state) => state.clases);
  const loginStore = Redux.useSelector((state) => state.login);

  const isRoot = loginStore.user.roles.some((r) => r.name === SU);
  const isManager = !isRoot && isManagerUserCode(loginStore.user.userCodes, entidadesStore.activo?.id);

  const payload = {
    ...clasesStore.params,
    entityId: entidadesStore.activo.id,
  };

  React.useEffect(() => {
    async function fetchData() {
      dispatch({ type: PARAMS_CLASES, payload });
      if (clasesStore.all && clasesStore.all.length === 0) {
        await getAllClasesAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [rows, setRows] = React.useState([]);
  const [loadingDelete, setLoadingDelete] = React.useState(false);

  const _handleInfoClick = async (id) => {
    const res = clasesStore.all.find((el) => el.id === id);
    await setActivoClasesAction(dispatch, res);
    history.push(ROUTES.panelClases.to);
  };

  const _handleEditClick = async (id) => {
    const res = clasesStore.all.find((el) => el.id === id);
    await setActivoClasesAction(dispatch, res);
    setOpenModalForm(true);
  };

  const [isDelete, setIsDelete] = React.useState(false);
  const [isToggleActive, setIsToggleActive] = React.useState(false);
  const _handleDeleteClick = async (id) => {
    setLoadingDelete(true);
    await deleteClasesAction(
      { dispatch, addNotification },
      id,
      clasesStore.params
    );
    setIsDelete(false);
    setLoadingDelete(false);
  };

  const _handleToggleActiveClick = async (id) => {
    setLoadingDelete(true);
    await saveClasesAction(
      { dispatch, addNotification },
      id,
      {
        active: !clasesStore.activo.active,
      },
      clasesStore.params
    );
    setIsToggleActive(false);
    setLoadingDelete(false);
  };

  React.useEffect(() => {
    setRows([]);
    clasesStore.all.forEach((el) => {
      setRows((old) => [
        ...old,
        {
          ...el,
          type: el.type === 'informative' ? 'Informativa' : 'Reservable',
          [CONST.CLASS_CATEGORY_ID]: el.category?.name ?? 'N/A',
          active: el.active ? 'Activo' : 'Bloqueado',
          date: `${moment(el.startDate).format('DD-MM-YYYY')} - ${moment(el.endDate).format('DD-MM-YYYY')}`,
          actions: el,
        },
      ]);
    });
  }, [clasesStore.all]);

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.IMAGE_URL,
      label: 'Imagen',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar alt={value} sx={{ width: 30, height: 30 }} src={value} />
          );
        },
      },
    },
    {
      name: CONST.NAME,
      label: 'Nombre',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleInfoClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: 'date',
      label: 'Fecha',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'type',
      label: 'Tipo',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.CLASS_CATEGORY_ID,
      label: 'Categoría',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.ACTIVE,
      label: 'Estatus',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                sx={{
                  backgroundColor:
                    value === 'Activo' ? CYAN_COLOR : MORADO_COLOR,
                  color: 'white',
                }}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.ACTIONS,
      label: 'Acción',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box align="left" sx={{ display: 'flex', flexDirection: 'row' }}>
                <Tooltip title="Información">
                  <IconButton
                    aria-label="edit"
                    size="small"
                    color="primary"
                    onClick={() => _handleInfoClick(tableMeta.rowData[0])}
                  >
                    <VisibilityIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                {
                  !isManager && (
                    <ActionsList
                      id={tableMeta.rowData[0]}
                      onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                      onDelete={async () => {
                        await setActivoClasesAction(dispatch, value);
                        setIsDelete(true);
                      }}
                      onToggleActive={async () => {
                        await setActivoClasesAction(dispatch, value);
                        setIsToggleActive(true);
                      }}
                      active={value.active}
                    />
                  )
                }
              </Box>
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return (
        <ExpandeRowClases
          data={clasesStore.all.find((el) => el.id === rowData[0])}
          length={rowData.length}
        />
      );
    },

    onDownload: () => {
      const url = `${clasesApi}/export`;
      const name = 'clases';
      const params = payload;
      downloadExcelFile(url, params, name, addNotification);
      return false;
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels: textLabelsTable,
  };

  return (
    <Grid container>
      <LoadingComponent
        isLoading={clasesStore.loadingGetAll || loadingDelete}
        text="Cargando lista..."
      />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {clasesStore.activo ? (
        <Modal
          id="modalEliminarArea"
          title={`Eliminar ${clasesStore.activo.name}`}
          open={isDelete}
          maxWidth="sm"
          onClose={() => setIsDelete(!isDelete)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              ¿Seguro que quieres eliminar esta clase?
              <p>
                <strong>{clasesStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleDeleteClick(clasesStore.activo.id);
              }}
            >
              ELIMINAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsDelete(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      ) : null}

      {clasesStore.activo ? (
        <Modal
          id="modalToggleActivo"
          title={`${clasesStore.activo.active ? 'Bloquear' : 'Activar'} ${
            clasesStore.activo.name
          }`}
          open={isToggleActive}
          maxWidth="sm"
          onClose={() => setIsToggleActive(!isToggleActive)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`¿Seguro que quieres ${
                clasesStore.activo.active ? 'Bloquear' : 'Activar'
              } esta clase?`}
              <p>
                <strong>{clasesStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleToggleActiveClick(clasesStore.activo.id);
              }}
            >
              ACEPTAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsToggleActive(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      ) : null}
    </Grid>
  );
};

export default ListadoClases;
